"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ListGripper;

var _ListGripper = require("@adobe/react-spectrum-ui/dist/ListGripper");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function ListGripper(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_ListGripper.ListGripper, null));
}